/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Menu, MenuItem } from '@mui/material';

import { routes } from '@/infrastructure/const/routes';
import { useAuth } from '@/infrastructure/context/auth-context';
import {
  LoginRounded,
  LogoutRounded,
  AccountCircleOutlined,
} from '@mui/icons-material';

interface IProfileBtnFormProps {
  open: boolean;
  anchorEl: null | HTMLElement;
  handleClose: () => void;
}

const ProfileBtnForm: React.FC<IProfileBtnFormProps> = (props) => {
  const { open, anchorEl, handleClose = () => {} } = props;
  const { t: tButtons } = useTranslation('buttons');

  const router = useRouter();

  const { authUser, signOut, checkAuth } = useAuth();

  const onLogin = async () => {
    handleClose();
    await checkAuth();
  };

  const onLogout = async () => {
    await signOut();
  };
  const onProfile = () => {
    router.push(routes.profile);
  };

  const menuItems = useMemo(() => {
    return [
      {
        title: tButtons('login'),
        icon: <LoginRounded />,
        visible: !authUser,
        action: onLogin,
      },
      {
        title: tButtons('Profile'),
        icon: <AccountCircleOutlined />,
        visible: !!authUser,
        action: onProfile,
      },
      {
        title: tButtons('logout'),
        icon: <LogoutRounded />,
        visible: !!authUser,
        action: onLogout,
      },
    ];
  }, [authUser]);

  return (
    <div>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {menuItems.map(
          (menuItem) =>
            menuItem.visible && (
              <MenuItem key={menuItem.title} onClick={menuItem.action}>
                <i>{menuItem.icon}</i>
                <span>{menuItem.title}</span>
              </MenuItem>
            )
        )}
      </Menu>
    </div>
  );
};

export default ProfileBtnForm;
